import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ManagerNavbar from "../Layout/ManagerNavbar";
import { FaUser, FaCalendarCheck, FaChevronRight } from "react-icons/fa";

const T = {
    bg: "#f8fafc",
    white: "#ffffff",
    border: "#e2e8f0",
    shadow: "0 1px 3px rgba(15,23,42,0.06), 0 0 0 1px rgba(15,23,42,0.04)",
    shadowMd: "0 4px 12px rgba(15,23,42,0.08)",
    radius: 12,
    text1: "#0f172a",
    text2: "#475569",
    text3: "#94a3b8",
    primary: "#6366f1",
};

const SLabel = ({ children }) => (
    <span style={{
        fontSize: "0.65rem", fontWeight: 700, color: T.text3,
        textTransform: "uppercase", letterSpacing: "0.08em",
    }}>
        {children}
    </span>
);

const CardBody = ({ item }) => {
    const Icon = item.icon;
    return (
        <div
            className="mgr-detail-card"
            style={{
                background: T.white,
                borderRadius: T.radius,
                padding: "18px 20px 16px",
                boxShadow: T.shadow,
                borderTop: `3px solid ${item.accent}`,
                transition: "box-shadow 0.2s",
                cursor: "pointer",
                height: "100%",
                boxSizing: "border-box",
            }}
        >
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 14 }}>
                <SLabel>{item.name}</SLabel>
                <div style={{
                    width: 32, height: 32, borderRadius: 8,
                    background: item.accent + "18",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                }}>
                    <Icon size={14} color={item.accent} />
                </div>
            </div>
            <div style={{ fontSize: "1.15rem", fontWeight: 800, color: T.text1, lineHeight: 1.2, marginBottom: 4 }}>
                {item.name}
            </div>
            <div style={{ fontSize: "0.73rem", color: T.text3 }}>
                Open module
            </div>
        </div>
    );
};

const ManagerDetailsLanding = () => {
    const navigate = useNavigate();
    const employeeId = localStorage.getItem("employeeId");

    const detailLinks = [
        { name: "View Details",     icon: FaUser,          accent: "#6366f1", onClick: () => navigate("/managerviewdetails", { state: { employeeId } }) },
        { name: "Holiday Calendar", icon: FaCalendarCheck, accent: "#10b981", path: "/mholidays" },
    ];

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
        }
    }, [navigate]);

    return (
        <>
            <div className="fixed-top">
                <ManagerNavbar />
            </div>

            <div style={{ paddingTop: 108, minHeight: "100vh", background: T.bg, display: "flex", flexDirection: "column" }}>

                {/* ── Sub-nav strip ── */}
                <div style={{
                    background: T.white,
                    borderBottom: `1px solid ${T.border}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 24px",
                    height: 44,
                    flexShrink: 0,
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <div style={{
                            width: 28, height: 28, borderRadius: 7,
                            background: "#eef2ff",
                            display: "flex", alignItems: "center", justifyContent: "center",
                        }}>
                            <FaUser size={13} color={T.primary} />
                        </div>
                        <span style={{ fontSize: "0.85rem", fontWeight: 700, color: T.text1 }}>
                            My Details
                        </span>
                        <FaChevronRight size={10} color={T.text3} style={{ margin: "0 2px" }} />
                        <span style={{ fontSize: "0.78rem", color: T.text2 }}>Overview</span>
                    </div>

                    <span style={{
                        fontSize: "0.68rem", fontWeight: 800, color: T.text3,
                        textTransform: "uppercase", letterSpacing: "0.1em",
                    }}>
                        Manager
                    </span>
                </div>

                {/* ── Filter bar ── */}
                <div style={{
                    background: T.white,
                    borderBottom: `1px solid ${T.border}`,
                    boxShadow: "0 1px 4px rgba(15,23,42,0.05)",
                    padding: "0 24px",
                    height: 44,
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                }}>
                    <SLabel>Review your profile, employment info, and upcoming holidays</SLabel>
                </div>

                {/* ── Main content ── */}
                <div style={{ flex: 1, padding: "28px 24px 48px" }}>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                        gap: 16,
                    }}>
                        {detailLinks.map((item, idx) =>
                            item.onClick ? (
                                <div key={idx} onClick={item.onClick} style={{ textDecoration: "none" }}>
                                    <CardBody item={item} />
                                </div>
                            ) : (
                                <Link key={idx} to={item.path} style={{ textDecoration: "none" }}>
                                    <CardBody item={item} />
                                </Link>
                            )
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                .mgr-detail-card:hover {
                    box-shadow: ${T.shadowMd} !important;
                }
            `}</style>
        </>
    );
};

export default ManagerDetailsLanding;
